import { setRegisteredData } from "./registered-data";

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    $('section#application .page').addClass('d-none');
    $('section#application .page-game').removeClass('d-none');
    $('section#application .result').addClass('d-none');

    $(`section#application .result-${data.prize ? 'success' : 'failed'}`).removeClass('d-none');
    if (data.prize) {
        $('.result-prize-name').html(data.prize.name);
        $('.result-form-link').attr('href', data.formUrl);
    }
    setRegisteredData(data, 'section#application');
});

$('.game-run').on('click', function() {
    // page swap
    $('section#application .page').addClass('d-none');
    $('section#application .page-result').removeClass('d-none').css('display', 'block');

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('section#application .page').addClass('d-none');
    $('section#application .page-form').removeClass('d-none');
});

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');